import { enableProdMode } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Sentry from '@sentry/angular';

import { environment } from './environments/environment';

import 'hammerjs';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { versionInfo } from './app/version-info';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentry.dns,
  environment: environment.environment,
  normalizeDepth: 5,
  release: versionInfo.buildNumber,
  ignoreErrors: [
    'Illegal invocation',
    /Cannot read property 'loaded' of undefined/,
    /Can't find variable: fbq/,
    'fbq is not defined',
    '@safari-extension',
    'InvalidAccessError: The object does not support the operation or argument.',
    'Block-scoped declarations (let, const, function, class) not yet supported outside strict mode',
    /Failed to execute 'sendBeacon' on 'Navigator'/,
    'Non-Error promise rejection captured',
  ],
  beforeSend(event) {
    if (
      !environment.sentry.enabled ||
      window.location.href.includes('localhost')
    ) {
      // Console error message when developing
      console.error(event.message, event.extra);
      return null;
    }
    return event;
  },
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
